/* eslint-disable */
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
  let __root = "";

  if (globalThis.M2M_COMPONENTS_ENV === "local") {
    __root = "http://localhost:8080";
  }

  if (globalThis.M2M_COMPONENTS_ENV === "localDev") {
    __root = "";
  }

  if (globalThis.M2M_COMPONENTS_ENV === "development") {
    __root = "https://api-forms.dev.m2msystems.cloud";
  }

  if (globalThis.M2M_COMPONENTS_ENV === "production") {
    __root = "https://api-forms.m2msystems.cloud";
  }

  return __root;
};
/**
 * health check
 *
 */
export const healthCheck = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`health_check`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * DraftRevisionのフォーム情報を取得する
 *
 */
export const formGet = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 特定のRevisionのフォーム情報を取得する
 *
 */
export const formGetByRevision = ({
  id,
  revision,
}: {
  id: string;
  revision: string;
}) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}/${revision}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Formを新規作成する
 *
 */
export const formCreate = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * ユーザーに紐づいたフォームを全件取得する
 *
 */
export const formFindAll = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Formを更新する
 *
 */
export const formUpdate = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Formのシート機能を有効化する
 *
 */
export const formActivateSheetFeature = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}/sheets/activate`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Formの公開ステータスをPrivateに変更する
 *
 */
export const formPublishStatusChangeToPrivate = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}/private`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * FormのContentを更新する
 *
 */
export const formsCreateNewRevision = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Form内容を確定し公開する
 *
 */
export const formPublish = ({ id }: { id: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${id}/publish`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 質問を作成する
 *
 */
export const formQuestionCreate = ({ formId }: { formId: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${formId}/questions/append`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 質問を挿入する
 *
 */
export const formQuestionInsert = ({ formId }: { formId: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${formId}/questions/insert`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 質問を削除する
 *
 */
export const formQuestionDelete = ({ formId }: { formId: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${formId}/questions/delete`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 質問を更新する
 *
 */
export const formQuestionUpdate = ({
  formId,
  questionId,
}: {
  formId: string;
  questionId: string;
}) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${formId}/questions/${questionId}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 回答を取得
 *
 */
export const submissionGet = ({ formId }: { formId: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`forms/${formId}/submissions`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * 回答を作成
 *
 */
export const submissionCreate = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`submissions`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * ゲストがフォームの情報を取得する
 *
 */
export const guestFormGet = ({ formId }: { formId: string }) => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`guest/forms/${formId}`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Googleのトークンでサインインする
 *
 */
export const signInWithGoogle = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`auth/signInWithGoogle`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};

/**
 * Googleのトークンでサインアップする
 *
 */
export const signUpWithGoogle = () => {
  const __root = root();
  const __queries = Object.entries({})
    .filter(([_, value]) => {
      return value !== undefined;
    })
    .map(([key, value]) => {
      return `${key}=${value}`;
    })
    .join("&");
  const __path = `${__root}/${`auth/signUpWithGoogle`}`;
  return __queries ? `${__path}?${__queries}` : __path;
};
export const matsuriForms_v1 = {
  healthCheck,
  formGet,
  formGetByRevision,
  formCreate,
  formFindAll,
  formUpdate,
  formActivateSheetFeature,
  formPublishStatusChangeToPrivate,
  formsCreateNewRevision,
  formPublish,
  formQuestionCreate,
  formQuestionInsert,
  formQuestionDelete,
  formQuestionUpdate,
  submissionGet,
  submissionCreate,
  guestFormGet,
  signInWithGoogle,
  signUpWithGoogle,
};
